export class EmissionTargetColorValueConverter {
  toView(value) {

    if (value == 1) {
      return 'low';
    }
    if (value == 2) {
      return 'medium';
    }
    if (value == 3) {
      return 'high';
    }
    return 'notSet';

  }
}
